module.exports = __webpack_public_path__ + "media/images/lb/707-89e3509f39969871028741c551829824.svg";